<template>
  <TheTopbarModalLayout>
    <!-- menu header -->
    <template #header>
      <div class="diy-topbar__menu-profile" @click="openDIYModal(profileInfo), goToMenu(null)">
        <!-- profile picture -->
        <UserAvatar :user="currentUser" :tooltip="false" size="medium" />
        <!-- profile details -->
        <div class="diy-topbar__menu-profile-details">
          <span class="diy-topbar__menu-profile-name">{{ userFullName }}</span>
          <span class="diy-topbar__menu-profile-subtitle">
            {{ $t('topbar.menu.labels.view_profile') }}
          </span>
        </div>
      </div>
    </template>

    <!-- menu content -->
    <template #content>
      <!-- cuenta -->
      <TheTopbarNavbarMenuItem
        submenu
        @click="goToMenu('TheTopbarNavbarMenuAccount')"
        icon="far fa-cog"
      >
        {{ $t('topbar.menu.labels.account') }}
      </TheTopbarNavbarMenuItem>
      <!-- Tutorial -->
      <TheTopbarNavbarMenuItem
        v-if="!isEmployee"
        @click="goToMenu(null)"
        icon="far fa-question-circle"
      >
        Tutorial
      </TheTopbarNavbarMenuItem>
      <!-- Feedback -->
      <TheTopbarNavbarMenuItem
        v-if="!isEmployee"
        :href="clientURLs.feedbackFormUrl"
        @click="goToMenu(null)"
        icon="far fa-comment-alt-smile"
      >
        Feedback
      </TheTopbarNavbarMenuItem>
      <!-- Help -->
      <TheTopbarNavbarMenuItem
        v-if="!isEmployee"
        :href="clientURLs.helpFormUrl"
        @click="goToMenu(null)"
        icon="far fa-life-ring"
      >
        {{ $t('ui.links.help_form') }}
      </TheTopbarNavbarMenuItem>
      <!-- Log out -->
      <TheTopbarNavbarMenuItem @click="goToMenu(null), closeSession()" icon="far fa-sign-out-alt">
        {{ $t('topbar.menu.labels.log_out') }}
      </TheTopbarNavbarMenuItem>
    </template>
  </TheTopbarModalLayout>
</template>

<script>
// Utilities
import NavbarMenu from '../mixins/navbar-menu'
import { clientOptions } from 'Utils/config/diy'
import DIYModalControl from 'Mixins/DIYModalControl'
// Components
import UserAvatar from 'Components/UserAvatar'
import TheTopbarModalLayout from './TheTopbarModalLayout'

export default {
  name: 'TheTopbarNavbarMenuMain',

  components: {
    UserAvatar,
    TheTopbarModalLayout,
  },

  mixins: [NavbarMenu, DIYModalControl],

  data() {
    return {
      menuItems: null,

      clientURLs: {
        ...clientOptions,
      },

      profileInfo: {
        title: this.$t('ui.app.settings.profile'),
        component: 'ProfileInfo',
      },
    }
  },

  methods: {
    closeSession() {
      this.$store.dispatch('user/logout')
    },
  },

  computed: {
    userFullName() {
      return `${this.currentUser.first_name} ${this.currentUser.last_name}`
    },
  },
}
</script>

<style scoped>
.diy-topbar__menu-profile >>> .user__short-name {
  font-size: 18px;
  line-height: 32px;
}

.diy-topbar__menu-profile-details {
  display: flex;
  flex-direction: column;
}

.diy-topbar__menu-profile-name {
  font-size: 1.0625rem;
  line-height: 1.5625rem;
  font-weight: 700;
}

.diy-topbar__menu-profile-subtitle {
  font-size: 0.9375rem;
  line-height: 1.375rem;
  color: var(--c-secondary);
}
</style>

<style scoped src="@/assets/css/shared-styles/topbar-navbar.css"></style>
